// extracted by mini-css-extract-plugin
module.exports = {"formDesc":"RouteLeaving_formDesc__l2ucH","modalPaperClassName":"RouteLeaving_modalPaperClassName__1f7FO","mobileModalFooter":"RouteLeaving_mobileModalFooter__3BFyP"};